module.exports = __webpack_public_path__ + "img/type-of-platform-ar-kit.a3dd2c51.webp";